import React from "react";

export default class Receipt extends React.Component {
  render() {
    const date = new Date();
    return (
      <div
        style={{
          padding: "12pt",
          fontFamily: "'Roboto Mono', monospace",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <img
            src="/logo-mpp.png"
            style={{
              height: 80,
            }}
          />
          <img
            src="/pemkot.png"
            style={{
              height: 60,
            }}
          />
        </div>
        <h1
          style={{
            textAlign: "center",
            fontSize: 48,
            fontWeight: 600,
            marginTop: 25,
            marginBottom: 20,
          }}
        >
          {this.props.data.urutan}
        </h1>
        <table
          style={{
            width: "100%",
          }}
        >
          <tbody
            style={{
              fontSize: 14,
              verticalAlign: "top",
            }}
          >
            <tr
              style={{
                marginBottom: 4,
              }}
            >
              <td>Nama Tenant</td>
              <td>:</td>
              <td>{this.props.data.nama_layanan}</td>
            </tr>
            <tr>
              <td>Nama Layanan</td>
              <td>:</td>
              <td>{this.props.data.nama_sub_layanan}</td>
            </tr>
            <tr>
              <td width={110}>Jenis Antrian</td>
              <td>:</td>
              <td>{this.props.type}</td>
            </tr>
            <tr>
              <td>Nama Lengkap</td>
              <td>:</td>
              <td>{this.props.data.name}</td>
            </tr>
            <tr>
              <td>NIK</td>
              <td>:</td>
              <td>{this.props.data.nik}</td>
            </tr>
          </tbody>
        </table>
        <hr style={{ border: "1px solid gray", margin: "5mm 0" }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: 14,
            }}
          >{`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${(
            "0" + date.getHours()
          ).substr(-2)}:${("0" + date.getMinutes()).substr(-2)}`}</p>
          <img
            src="/partner-unikom.png"
            style={{
              height: 46,
            }}
          />
        </div>
      </div>
    );
  }
}
